export default __webpack_public_path__ + "static/media/iconDown.e78b3a6f.svg";